export const NO_DATA = "NO_DATA";
export const NOTE_NAME = "NOTE_NAME";
export const W360 = "W360";
export const FUND_CODE = "FUND_CODE";
export const RETURN_DESCRIPTION = "RETURN_DESCRIPTION";
export const PROTECTION = "PROTECTION";
export const UNDERLIER = "UNDERLIER";
export const TERM = "TERM";
export const AVAILABLE_UNTIL = "AVAILABLE_UNTIL";
export const EARLY_TRADING_PERIOD = "EARLY_TRADING_PERIOD";
export const CURRENCY = "CURRENCY";
export const PRODUCT_CLASS = "PRODUCT_CLASS";
export const SALES_COMMISSION = "SALES_COMMISSION";
export const STATUS_NAME = "STATUS_NAME";
export const DOWNLOAD_CSV = "DOWNLOAD_CSV";
export const PRINT = "PRINT";
export const HIDE_FILTERS = "HIDE_FILTERS";
export const ADVANCED_FILTERS = "ADVANCED_FILTERS";
export const SEARCH = "SEARCH";
export const INVESTOR_SUMMARY = "INVESTOR_SUMMARY";
export const noteType = "noteType"
export const noteSubType = "noteSubType"
export const productClass = "productClass"
export const currency = "currency"
export const termFrom = "termFrom"
export const termTo = "termTo"
export const status = "status"
